import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slide-settings"
export default class extends Controller {
  static targets = [
    "widgetsBtn",
    "widgetsSection",
    "embedsBtn",
    "embedsSection",
    "slideableBtn",
    "slideableSection",
  ]

  toggleWidgets(event) {
    event.preventDefault()
    this.closeAllSections()
    if (this.hasWidgetsSectionTarget) {
      this.widgetsSectionTarget.classList.toggle("hidden")
      this.widgetsBtnTarget.classList.toggle("bg-white")
      this.widgetsBtnTarget.classList.toggle("bg-emerald-200")
    }
  }

  toggleEmbeds(event) {
    event.preventDefault()
    this.closeAllSections()
    if (this.hasEmbedsSectionTarget) {
      this.embedsSectionTarget.classList.toggle("hidden")
      this.embedsBtnTarget.classList.toggle("bg-white")
      this.embedsBtnTarget.classList.toggle("bg-emerald-200")
    }
  }

  toggleSlideable(event) {
    event.preventDefault()
    this.closeAllSections()
    if (this.hasSlideableSectionTarget) {
      this.slideableSectionTarget.classList.toggle("hidden")
      this.slideableBtnTarget.classList.toggle("bg-white")
      this.slideableBtnTarget.classList.toggle("bg-emerald-200")
    }
  }

  closeAllSections() {
    const pairs = ["widgets", "embeds", "slideable"]
    pairs.forEach((name) => {
      const sectionTarget = `has${name.charAt(0).toUpperCase() + name.slice(1)}SectionTarget`
      const btnTarget = `has${name.charAt(0).toUpperCase() + name.slice(1)}BtnTarget`
      if (this[sectionTarget]) {
        this[`${name}SectionTarget`].classList.add("hidden")
      }
      if (this[btnTarget]) {
        this[`${name}BtnTarget`].classList.add("bg-white")
        this[`${name}BtnTarget`].classList.remove("bg-emerald-200")
      }
    })
  }
}
